import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ApiModule } from '../../api/api.module';
import { BackendPokerService } from '@damofire/uix-commons';

@NgModule({
  declarations: [],
  imports: [CommonModule, TranslateModule],
  exports: [TranslateModule, ApiModule],
  providers: [BackendPokerService],
})
export class CommonApiModule {
  static forRoot() {
    return {
      ngModule: CommonApiModule,
      providers: [],
    };
  }
}
